import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class PermissionsService {

    constructor(private api: ApiService) {
    }

    getList() {
        return this.api.get('/admin/permissions/').pipe(map(({result}) => result));
    }

    add(data) {
        return this.api.post('/admin/permissions/', data).pipe(map(({result}) => result));
    }

    update(data) {
        return this.api.put('/admin/permissions/' + data.id, data).pipe(map(({result}) => result));
    }


    delete(permission) {
        if (permission) {
            return this.api.delete('/admin/permissions/' + permission.id).pipe(map(response => response));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/permissions.service.ts